import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import ApplicationSkeleton from '~/components/ApplicationSkeleton';

const AsyncRouteCreate = lazy(() => import('~/containers/RouteCreate'));

export default [
  <Route path="/routes/create">
    <Suspense fallback={<ApplicationSkeleton />}>
      <AsyncRouteCreate />
    </Suspense>
  </Route>,
];
